import { Features } from '@anm/shared/features';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { domainsActions, domainsSelectors } from '../../../../store/modules/domains';
import { selectWaveSubscription } from '../../../../store/modules/user/selectors';

const useFetchDomains = () => {
  const dispatch = useDispatch();
  const isPending = useSelector(domainsSelectors.selectIsListPending);
  const isError = useSelector(domainsSelectors.selectIsListError);
  const domainsList = useSelector(domainsSelectors.selectDomainsList);
  const canUseCustomDomains = Features.canUseCustomDomains(useSelector(selectWaveSubscription));

  useEffect(() => {
    const canFetch = !domainsList && !isPending && !isError && canUseCustomDomains;

    canFetch && dispatch(domainsActions.fetchDomainsList());
  }, [domainsList, isPending, isError]);

  return [domainsList, isPending, canUseCustomDomains] as const;
};

export default useFetchDomains;
